import React from "react"
import SectionHeader from "../../blocks/SectionHeader"
import { useFetchStoreVars } from "Fetch"
import { sortData, ViewMoreButton } from "blocks/Accordion"
import Loading from "blocks/Loading"
import { relatedQuery } from "./query"
import { ResourceCard } from "./Resources"
import { useState } from "react"

import "./Resources.scss"

export default ({
  limit,
  current,
  relatedTo,
  manualResources = [],
  heading = "Related Resources"
}) => {
  let none = manualResources[0] && manualResources[0].hideResources
  let resources = manualResources[0] && manualResources[0].resources
  const [offset, setOffset] = useState(limit)

  const results = useFetchStoreVars(relatedQuery, { relatedTo: relatedTo }, `${current}-resource-related-to-${relatedTo}`)
  let data

  if (results) {
    data = sortData(results.entries)
    // Filter out unwanted IDs
    const idsToIgnore = [current, '20257', '20273', '20276']
    data = data.filter(resource => !idsToIgnore.includes(resource.id))

    // Merge manual resources if provided
    if (resources && resources.length) {
      let arr = resources.concat(data)
      // Remove duplicates
      data = Array.from(new Set(arr.filter(x => x).map(a => a.id)))
        .map(id => arr.find(a => a.id === id))
    }
  }

  return !none ? <section className="pad-top pad-bottom max-width">
    <SectionHeader heading={heading} />
    {data ? <>
      {data.slice(0, offset).length > 0 ? <ul className="grid grid--33" style={{ margin: '3rem 0' }}>
        {data.slice(0, offset).map(resource => {
          return <li key={`resource_${resource.id}`}>
            <ResourceCard resource={resource} />
          </li>
        })}
      </ul> : null}
      <ViewMoreButton
        buttonClass="center"
        setOffset={setOffset}
        offset={offset}
        limit={limit}
        total={data.length} />
    </> : <Loading />}
  </section> : null
}

// const ManualResources = ({resources,limit}) => {
//   const [offset,setOffset] = useState(limit)

//   return resources ? <React.Fragment>
//     <List data={resources.slice(0,offset)} />
//     <ViewMoreButton
//       buttonClass={"center"}
//       setOffset={setOffset}
//       offset={offset}
//       limit={limit}
//       total={resources.length} />
//   </React.Fragment> : null
// }

// const List = ({data}) => {
//   return <ul className="grid grid--33" style={{margin: '3rem 0'}}>
//     {data.map(resource => {
//       return <li key={`resource_${resource.id}`}>
//         <ResourceCard resource={resource} />
//       </li>
//     })}
//   </ul>
// }
